export default __webpack_public_path__ + "static/media/Edital FINAL PRELIMINAR.5f0e014b.pdf";